module.exports = __webpack_public_path__ + "media/images/riders/ONDREJ_CINK-50dfd91a318d0d41f2ef04cd835c1ad7.png";